<template>
    <!-- 底部弹出的体检评估项 -->
    <van-popup position="bottom" v-model="visible" :style="{ height: '100%' }" class="popup-wrapper">
        <div v-if="userRatingResult">
            <div class="comment-body">
                <h2>您对本次体检是否满意?</h2>
                <van-rate v-model="ratingData.total_rating" size="24" @change="onTotalRatingChanged" />
                <div style="padding:16px;">
                    <div class="rate-wrapper">
                        <div v-for="(ratingItem,index) in ratingData.rating_items" :key="index" class="rate__row">
                            <p class="rate__label">{{ratingItem.item_name}}</p>
                            <div style="align-items: center;display: flex;">
                                <van-rate v-model="ratingItem.rating" />
                            </div>
                        </div>
                    </div>
                    <!-- 
                        <div contenteditable="true" placeholder="敬请留下更多的宝贵意见" v-model="ratingData.comment"
                            class="comment-edit"></div> -->

                    <van-field class="comment-edit" v-model="ratingData.comment" rows="2" autosize type="textarea"
                        placeholder="敬请留下更多的宝贵意见" />
                </div>
            </div>

            <div class="footer">
                <div>
                    <van-button type="info" size="large" round @click="saveRating()">提交评价</van-button>
                </div>
            </div>
        </div>
    </van-popup>
</template>
<style lang="less" scoped>
    /deep/ .van-step--finish .van-step__circle {
        background-color: var(--color-main);
    }

    .popup-wrapper {
        .popup-title {
            font-size: 18px;
            font-weight: 400;
            line-height: 48px;
            margin: 0 16px;
        }

        .report-item-row {
            margin: 0 16px;
            display: flex;
            font-size: 14px;
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);

            .report-item-name {
                flex: 1;
            }

            .report-item-status {
                font-size: 13px;
                color: rgba(0, 0, 0, 0.45)
            }
        }

        .comment-body {
            overflow: hidden;
            background-color: #fff;
            border-radius: 4px;
            box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
            text-align: center;
            padding: 24px 0;

            h2 {
                text-align: center;
                font-size: 20px;
                font-weight: 400;
                margin: 24px 0;
            }
        }

        .queue-head {
            display: flex;
            border-bottom: 1px dashed #bababa;

            .queue-head__station {
                flex: 1;
            }

            h2 {
                font-size: 20px;
                font-weight: 400;
            }

            span {
                color: #bababa;
            }
        }

        .rate-wrapper {
            margin-top: 12px;
            font-size: 14px;
            padding: 0 16px;

            .rate__row {
                padding: 16px 0;
                line-height: 32px;
                text-align: left;
            }

            .rate__label {
                color: #888888;
                width: 100%;
            }
        }

        .block-title {
            margin: 0;
            padding: 24px 16px 16px;
            color: rgba(69, 90, 100);
            font-weight: normal;
            font-size: 18px;
            text-align: center;
        }

        .comment-edit {
            margin: 24px 8px;
            border: 1px solid #dbdbdb;
            background-color: #fafafa;
            width: auto;
            min-height: 48px;
            text-align: left;
            font-size: 14px;
            padding: 12px;
        }

        .comment-edit:blur {
            border: 1px solid var(--color-main);
        }

        div[contenteditable]:empty:before {
            content: attr(placeholder);
            color: #cccccc;
        }

        div[contenteditable]:focus {
            content: none;
        }

        .footer {
            width: 100%;
            position: fixed;
            left: 0px;
            bottom: 10px;

            div {
                padding: 0 16px;
            }
        }

        /deep/ .van-button--large {
            height: 42px;
            line-height: 42px;
        }

    }
</style>

<script>
    import Vue from "vue";
    import {
        mapState
    } from "vuex";
    import {
        Step,
        Steps,
        Toast
    } from "vant";
    import headerNavbar from '../components/headerNavbar';
    Vue.use(Step);
    Vue.use(Steps);
    import {
        Tab,
        Tabs
    } from "vant";
    Vue.use(Tab).use(Tabs);

    import {
        Cell,
        CellGroup
    } from "vant";
    Vue.use(Cell).use(CellGroup);

    import {
        Button
    } from "vant";
    Vue.use(Button);

    import {
        Rate
    } from "vant";
    Vue.use(Rate);
    import * as api_user from "@/api/user";
    import * as auth from "@/libs/auth";
    import * as api_report from "@/api/report";
    import * as api_rating from "@/api/rating";
    export default {
        name: "ratingDialog",
        components: {
            headerNavbar
        },
        data() {
            return {
                reports: null,
                report: null,
                processingReports: [],
                completedReports: [],
                userRatingResult: Object,
                showPopup: false,
                total_rating: 3,
                details: [{
                        title: "前台服务",
                        rate: 0
                    },
                    {
                        title: "医生服务",
                        rate: 0
                    },
                    {
                        title: "护士服务",
                        rate: 0
                    },
                    {
                        title: "体检流程",
                        rate: 0
                    }
                ],
                ratingData: {}
            };
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            examNo: {
                type: String
            },
            userProfile: {
                type: Object
            }
        },
        watch: {
            visible: function (newVal, oldVal) {
                if (newVal) {
                    this.showRating();
                }
            }
        },
        computed: {
            ...mapState({
                configs: state => state.hospital.configs
            }),
            userRatingResponse() {
                if (this.configs && this.configs.length) {
                    var config = this.configs.find(it => {
                        return it.code == "user_rating_response"
                    });
                    if (config && config.value) {
                        return config.value.split("|");
                    }
                }
                return ['', '', '', '', ''];
            }
        },
        async mounted() {

        },
        //
        methods: {
            showRating() {
                let _this = this;
                api_rating.getRating(this.examNo).then(res => {
                    if (res.data) {
                        _this.ratingData = res.data;
                        if (!_this.ratingData.is_rated) {
                            _this.ratingData.account_id = _this.userProfile.account_id;
                            _this.ratingData.profile_id = _this.userProfile.id;
                            _this.ratingData.user_mobile = _this.userProfile.phone;
                            _this.ratingData.user_name = _this.userProfile.name;
                        }
                    }
                })
            },
            /**显示用户提交评价的提示文本信息 */
            showRatingResponse(rating) {
                if (rating > 0 && rating <= 5) {
                    if (this.configs && this.configs.length) {
                        var config = this.configs.find(it => {
                            return it.code == "user_rating_response"
                        });
                        if (config && config.value) {
                            var list = config.value.split("|");
                            if (list && list.length == 5) {
                                var text = list[rating - 1];
                                if (text !== null && text !== '')
                                    this.$Dialog.alert({
                                        message: text,
                                    }).then(() => {
                                        // this.showPopup = false;
                                        // this.getRecords();
                                        // return;
                                    });
                            }
                        }
                    }

                }
            },
            saveRating() {
                let _this = this;
                if (_this.ratingData.total_rating == 0 ||
                    _this.ratingData.rating_items.findIndex(i => i.rating == 0) > 0) {
                    _this.$toast("请给所有评分项打星");
                    return;
                }
                api_rating.saveRating(_this.ratingData).then(
                    res => {
                        if (res.code != 200) {
                            _this.$toast.fail("提交出错了！");
                        } else {
                            _this.showRatingResponse(_this.ratingData.total_rating);
                        }
                        _this.$emit('change');
                    }
                ).catch(
                    err => {
                        console.log(err);
                        _this.$toast.fail("提交出错了！")
                        _this.$emit('change');
                    }
                )
            },
            onTotalRatingChanged(value) {
                this.ratingData.rating_items.forEach(r => r.rating = value);
            }
        },
    };
</script>